const riot = require('riot');

riot.tag2('page-thanks', '<div class="s-full min-height-100per" if="{event}"> <div class="f fclm container-538 s-full"> <div data-is="module-thanks-{event.point_provider}" event="{event}"></div> <module-footer class="bg-gray_05 pt32 pb20 px24 mta" event="{event}" is-hide-terms="{event.point_provider === &quot;paypay&quot;}"></module-footer> </div> </div>', 'page-thanks,[data-is="page-thanks"]{display:block}', '', function(opts) {
    this.preload = async ({req}) => {
      const onetime_hash = req.query.hash;
      if (!onetime_hash) throw { status: 404 };

      const event = await app.api.child('distribution_event').get({
        onetime_hash,
      });

      return {
        event,
      };
    };

    this.head = () => {
      return {
        title: '受け取り画面 | Repro Incentive',
      };
    };
});